import { useState, useEffect, useRef, useContext } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { OverlayPanel } from "primereact/overlaypanel";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";

// ------------------ COMPONENTES DE BASE--------------------------

// ------------------ CONSULTAS A LA API--------------------------
import AgGrid from "../../../../../Base/Components/Tables/AgGrid/AgGrid";
import { AuthContext } from "../../../../../Base/Context/AuthContext/AuthContext";
import { ObtenerIngresosSinEliminar } from "../../../../../API/Suministros/IngresosBodega/IngresosBodegaDetalleRequest";

const OverlayIngresos = ({ close, rowData, onChange }) => {
  const op = useRef(null);
  const buttom = useRef(null);
  const { userAuth } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [activos, setActivos] = useState([]);

  const fetchData = async () => {
    try {
      const response = await ObtenerIngresosSinEliminar();
      setActivos(response);
    } catch (error) {
      console.error("Error al llamar a la API:", error);
    }
  };

  const columns = [
    {
      // Comment
      field: "IdIngresoDetalle",
      header: "ID",
      headerEn: "ID",
      className: "colum-width-Xlarge",
      body: (rowData) => rowData.IdIngresoDetalle,
      frozen: "frozen",
      className: "XXsmall",
      hidden: userAuth.IdRol === 1,
    },
    {
      // Comment
      field: "FechaIngreso",
      header: "Fecha Ingreso",
      headerEn: "Fecha Ingreso",
      className: "colum-width-Xlarge",
      body: (rowData) => rowData.FechaIngreso,
      frozen: "frozen",
      className: "small",
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "StatusName",
      className: "medium",
      frozen: true,
      Format: "Estado",
      body: (rowData) => ({ ID: rowData.IdEstado, Estado: rowData.StatusName }),
    },
    {
      // PurchaseRequest
      field: "NumeroIngreso",
      headerEn: "Entry Number",
      header: "No. Ingreso",
      className: "small",
      body: (rowData) => rowData.NumeroIngreso,
      Format: "Modal",
      align: "center",
      Sumary: "count",
      frozen: "frozen",
    },
    {
      // Comment
      field: "CodigoProducto",
      header: "Código",
      headerEn: "Code",
      // frozen: true,
      className: "Xsmall",
      body: (rowData) => rowData.CodigoProducto,
    },
    {
      // Comment
      field: "NombreProducto",
      header: "Nombre Producto",
      headerEn: "Product Name",
      className: "Xlarge",
    },
    {
      // Comment
      field: "NombreCategoria",
      header: "Tipo Producto",
      headerEn: "Product Type",
      className: "small",
    },
    {
      // Comment
      field: "NombreSubcategoria",
      header: "Categoría",
      headerEn: "Category",
      className: "small",
    },
    {
      // Comment
      field: "NombreTipoProducto",
      header: "Categoría",
      headerEn: "Category",
      className: "small",
    },
    {
      // Comment
      field: "CustomerName",
      header: "Proveedor",
      headerEn: "Supplier",
      className: "Xlarge",
    },
    {
      // Comment
      field: "Term",
      header: "Término de Compra",
      headerEn: "Purchase Term",
      className: "small",
    },
    {
      // Comment
      field: "Factura",
      header: "Factura",
      headerEn: "Invoice",
      className: "large",
    },
    {
      // Comment
      field: "NombreBodega",
      header: "Bodega",
      headerEn: "Warehouse Name",
      className: "large",
      body: (rowData) => rowData.NombreBodega,
    },
    {
      // Comment
      field: "NombreEstante",
      header: "Estante",
      headerEn: "Shelf Name",
      className: "Xsmall",
      body: (rowData) => rowData.NombreEstante,
    },
    {
      // Comment
      field: "NombrePosicion",
      header: "Fila",
      headerEn: "Position Name",
      className: "Xsmall",
      body: (rowData) => rowData.NombrePosicion,
    },
    {
      // Comment
      field: "NombreBandeja",
      header: "Bandeja",
      // headerEn: "Position Name",
      className: "Xsmall",
      body: (rowData) => rowData.NombreBandeja,
    },
    {
      // Comment
      field: "UnitName",
      header: "Unidad",
      headerEn: "Unit",
      className: "Xsmall",
      body: (rowData) => rowData.UnitName,
    },
    {
      // Comment
      field: "Currency",
      header: "Moneda",
      headerEn: "Currency",
      className: "Xsmall",
      body: (rowData) => rowData.Currency,
    },
    {
      header: "Ingresado",
      headerEn: "Type",
      field: "Ingreso",
      Format: "Currency",
      className: "Xsmall",
      frozen: true,
      Sumary: "sum",
      alignFrozen: "right",
    },
    {
      // Comment
      field: "Inventario",
      header: "Inventario",
      headerEn: "Inventary",
      Format: "Currency",
      Sumary: "sum",
      className: "Xsmall",
      body: (rowData) => rowData.Inventario,
    },
    {
      // Comment
      field: "TasaCambio",
      header: "Tasa Cambio",
      headerEn: "Exchange Rate",
      Format: "Decimal",
      // Sumary: "sum",
      className: "Xsmall",
      body: (rowData) => rowData.TasaCambio,
      hidden: userAuth.IdRol === 1,
    },
  ];

  const table = {
    Data: activos,
    loading: loading,
    Columns: columns,
    onCellClicked: (e) => onChange(e, rowData),
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div style={{ maxWidth: "50vw" }}>
      <div className="p-inputgroup">
        <InputText
          value={rowData.NumeroIngreso}
          disabled
          placeholder="NumeroIngreso"
          onClick={(e) => op.current.toggle(e)}
        />
        <Button
          ref={buttom}
          icon="pi pi-chevron-down"
          style={{ padding: "0.5rem 0.3rem" }}
          type="button"
          onClick={(e) => op.current.toggle(e)}
        />
      </div>

      <OverlayPanel
        ref={op}
        showCloseIcon
        dismissable={false}
        className="OverPanelProductos"
        onHide={close}
      >
        <div style={{ width: 1300, height: 300 }}>
          <AgGrid table={table} />
        </div>
      </OverlayPanel>
    </div>
  );
};

export default OverlayIngresos;
